import React from "react";
import { Index } from "../components/FooterTexts/KVKK/Index";

export const KVKK = () => {
  return <Index />;
};
